// Content for the Permis ATNA final call to action.
export type Bi = { fr: string; en: string }

export const PERMIS_CTA_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/e52cb635-c1fb-488d-a501-31c514d8ffa3.jpg'

export const permisCtaCopy = {
  eyebrow: { fr: 'Commencez aujourd’hui', en: 'Start today' },
  line1: { fr: 'Et si votre prochain', en: 'What if your next' },
  line2: { fr: 'permis commençait', en: 'permit started' },
  line3: { fr: 'simplement par', en: 'simply with' },
  line4: { fr: 'une question ?', en: 'a question?' },
  bodyBefore: { fr: 'Voyez comment ', en: 'See how ' },
  bodyLead: { fr: 'Permis ATNA', en: 'ATNA Permits' },
  bodyAfter: {
    fr: ' peut s’adapter à vos règlements, vos processus et vos systèmes existants.',
    en: ' can adapt to your by-laws, your processes and your existing systems.',
  },
  primary: { fr: 'Voir Permis ATNA en action', en: 'See ATNA Permits in action' },
  secondary: { fr: 'Parler à notre équipe', en: 'Talk to our team' },
  question: {
    fr: 'Je veux louer ma maison sur Airbnb cet été. Qu’est-ce que je dois faire ?',
    en: 'I want to rent my house on Airbnb this summer. What do I need to do?',
  },
  answer: {
    fr: 'Voici ce qu’il vous faut pour louer votre propriété à court terme à Clarence-Rockland.',
    en: 'Here’s what you need to rent your property short term in Clarence-Rockland.',
  },
  tagline: { fr: 'Une intelligence de confiance. Conçue pour agir.', en: 'Trusted Intelligence. Built to Act.' },
}

export const permisCtaSteps: { key: 'property' | 'rules' | 'permit'; title: Bi; body: Bi }[] = [
  { key: 'property', title: { fr: 'Propriété identifiée', en: 'Property identified' }, body: { fr: '123, rue Principale, Clarence-Rockland', en: '123 Principale St., Clarence-Rockland' } },
  { key: 'rules', title: { fr: 'Règles vérifiées', en: 'Rules verified' }, body: { fr: 'Location à court terme autorisée sous conditions', en: 'Short-term rental allowed under conditions' } },
  { key: 'permit', title: { fr: 'Permis identifié', en: 'Permit identified' }, body: { fr: 'Permis de location à court terme requis', en: 'Short-term rental permit required' } },
]
